import { render, staticRenderFns } from "./LightboxCustomPanoramaCard.vue?vue&type=template&id=2a4305d6&scoped=true&"
import script from "./LightboxCustomPanoramaCard.vue?vue&type=script&lang=js&"
export * from "./LightboxCustomPanoramaCard.vue?vue&type=script&lang=js&"
import style0 from "./LightboxCustomPanoramaCard.vue?vue&type=style&index=0&id=2a4305d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4305d6",
  null
  
)

export default component.exports